import React, { Component } from 'react';
import { Dimmer, Loader, Grid } from 'semantic-ui-react'
import FormatCurrency from "../FormatCurrency"
import { changeFontColor } from "../../shared/helpers/styles";

export default class BudgetHeader extends Component {

    render() {

        const PageLoader = () => (
            <Dimmer active={this.props.showLoader} inverted>
                <Loader size='medium'>Loading Budget Summary ...</Loader>
            </Dimmer>
        );

        return (
            <div>
                <PageLoader />
                <Grid textAlign='center'>
                    <Grid.Row className='grid-padding'>
                        <Grid.Column width={2} textAlign='center' >
                            <b>Total Income</b>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <b>Total Expenses</b>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <b>DTI</b>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <b>Cash Flow</b>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <b>Total Assets</b>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <b>Total Liens</b>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row className='grid-padding'>
                        <Grid.Column width={2} textAlign='center' >
                            <div className={changeFontColor(this.props.incomes_total)}>
                                <FormatCurrency amount={this.props.incomes_total} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <div className={changeFontColor(this.props.expenses_total)}>
                                <FormatCurrency amount={this.props.expenses_total} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <div className={changeFontColor(this.props.dti)}>
                                {this.props.dti}%
                            </div>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <div className={changeFontColor(this.props.cash_flow)}>
                                <FormatCurrency amount={this.props.cash_flow} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <div className={changeFontColor(this.props.assets_total)}>
                                <FormatCurrency amount={this.props.assets_total} />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' >
                            <div className={changeFontColor(this.props.liens_total)}>
                                <FormatCurrency amount={this.props.liens_total} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BudgetHeader/index.js